import React from 'react';
const DarkMode = () => <div className="p-8"><h1 className="text-2xl font-bold">Dark Mode Page</h1></div>;
export default DarkMode; 